export default {
	IDM_CLIENT_ID: 'internalMarketingTools',
	ID_GATEWAY_URL: 'http://IdGateway.idm.local',
	ORG_SERVICE_URL: 'http://organizationsvc.idm.local',
};
